import { InputSkeleton, Skeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <section className="mt-4 flex flex-col overflow-x-auto">
              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>

              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>

              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>

              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>

              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>
              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>
              <div className="border-c-border mt-0 w-full border-b pt-2.5 pb-3">
                <section className="flex items-end gap-1 gap-x-2">
                  <div className="w-7 shrink-0 grow-0 pb-0.5">
                    <Skeleton className="h-4 w-5" />
                  </div>
                  <div className="text-accent text-md w-48 shrink-0 grow-0 text-left font-semibold dark:text-white">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                  <div className="flex min-w-12 flex-1 flex-col items-center gap-3">
                    <Skeleton className="h-5 w-5" />
                  </div>
                </section>
              </div>
            </section>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
